import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { useChartData } from "../../context/ChartDataContext";

const ApexChart5 = () => {
	const [state, setState] = React.useState({
		series: [{
			name: 'Point',
			type: 'scatter',
			data: []
		}, {
			name: 'Line',
			type: 'line',
			data: []
		}],
		options: {
			chart: {
				height: 350,
				type: 'line',
			},
			colors: ["#FF4560", "#4ECDC4"],
			fill: {
			  type:'solid',
			},
			fill: {
				type:'solid',
			},
			markers: {
				size: [3.2, 0]
			},
			tooltip: {
				shared: true,
				intersect: false,
				x: {
					format: 'dd MMM yyyy HH:mm:00'
				},
				y: {
					formatter: function (y) {
						if (typeof y !== "undefined" && y !== null) {
							return y.toFixed(2) + " W";
						}
						return null; // This will hide the series from tooltip when no data
					}
				}
			},
			legend: {
				show: true,
				fontSize: '16px',
				fontWeight: 'bold'
			},
			xaxis: {
				type: 'datetime',
				tickAmount: 6
			},
			yaxis: {
				labels: {
					formatter: function (value) {
						return value.toFixed(0);
					}
				}
			},
		}
	});
	
	const { chartData, loading, error } = useChartData();

	useEffect(() => {
		if (chartData && chartData.mpp_vec) {
			// Convert your model data to the format needed using actual timestamps
			const predictedData = chartData.mpp_vec.map((point) => ({
				x: point[0], // Use actual timestamp
				y: point[1]  // Use actual value
			}));
			
			// Create validation data that matches predicted data timestamps
			let validationData = [];
			if (chartData.validation_data && chartData.validation_data.pmpp_real && chartData.validation_data.pmpp_real.length > 0) {
				// Map validation data to match predicted data timestamps
				validationData = chartData.mpp_vec.map((point, index) => {
					const timestamp = point[0];
					// Find corresponding validation data for this timestamp
					const validationIndex = chartData.validation_data.time_real.findIndex(t => t === timestamp);
					const validationValue = validationIndex !== -1 ? chartData.validation_data.pmpp_real[validationIndex] : null;
					
					return {
						x: timestamp,
						y: validationValue
					};
				});
			}
			
			const series = [{
				name: 'Measured data',
				type: 'scatter',
				data: validationData
			}, {
				name: 'Predicted values',
				type: 'line',
				data: predictedData
			}];
			
			setState(prev => ({
				...prev,
				series: series
			}));
		}
	}, [chartData]);

	return (
		<div>
			<div id="chart">
				<div id="chart-timeline">
					<ReactApexChart options={state.options} series={state.series} type="line" height={350} />
				</div>
			</div>
			<div id="html-dist"></div>
		</div>
	);
};

export default ApexChart5; 